import React from 'react';
import { Action, withInject } from '@piwikpro/platform';
import { TFunction } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import {
  Stack,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import { MetaSitesState } from '@piwikpro/meta-sites-crate/reducers';

const mapStateToProps = (state: MetaSitesState) => ({
  metaSite: state.metaSites.details.settings.settings,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  metaSites: any
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

class TrackingECommerce extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, { setFieldValue, setSubmitting }) {
    const { metaSites, metaSite } = this.props;

    try {
      await metaSites.updateMetaSite(metaSite.id, values);
    } catch (err) {
      setFieldValue('e_commerce_tracking', !values.e_commerce_tracking, false);
    }

    setSubmitting(false);
  }

  render() {
    const {
      metaSite,
      t,
    } = this.props;

    return (
      <Stack wrap verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.tracking.ecommerce.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.tracking.ecommerce.description')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Action.AutoSavedSwitcherControl
            id="meta-site-settings-tracking-e-commerce"
            initialValue={metaSite.attributes.e_commerce_tracking}
            name="e_commerce_tracking"
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default connector(withInject<InjectedProps>({
  metaSites: 'MetaSitesCrate.metaSites',
})(
  withTranslation(['administration'])(TrackingECommerce),
));
